import { BadgeColor } from "@quortex/front-common"

export interface QoEStatusCardProps {
  overallQoe: api.switchns.OverallQoE
  className?: string
}

export const statusToColor: Record<api.switchns.OverallQoE["qoeStatus"], BadgeColor> = {
  DISABLED: BadgeColor.GREY,
  ERROR: BadgeColor.ERROR,
  HEALTHY: BadgeColor.SUCCESS,
  NO_DATA: BadgeColor.GREY,
  READY: BadgeColor.SUCCESS,
  WARNING: BadgeColor.WARNING
}

export { default as QoEStatusCard } from "./QoEStatusCard"
